<div class="data-table-scroll">
  <table
    mat-table
    [dataSource]="dataSource"
    class="mat-mdc-table data-table"
    [style.min-width]="minTableWidth"
    [attr.data-testid]="testId"
  >
    @for (column of columns; track column.key) {
      <ng-container [matColumnDef]="column.key">
        <th
          mat-header-cell
          *matHeaderCellDef
          [class]="column.headerClass || ''"
          [style.min-width]="column.minWidth || null"
          [class.sortable]="column.sortable"
          (click)="column.sortable ? onSortHeaderClick(column) : null"
        >
          <div class="header-content" [class.sort-header]="column.sortable">
            <span class="p5">{{ column.label }}</span>
            @if (getFilterForColumn(column); as filter) {
              <button
                type="button"
                class="filter-icon"
                [class.filter-active]="hasActiveFilterValues(filter.field)"
                [matMenuTriggerFor]="columnFilterMenu"
                #filterTrigger="matMenuTrigger"
                (menuOpened)="onColumnFilterMenuOpened(filter.field, filterTrigger)"
                (click)="
                  onColumnFilterMenuOpened(filter.field, filterTrigger); $event.stopPropagation()
                "
                [attr.aria-label]="'Filter by ' + filter.label"
              >
                <img src="assets/images/table/tabler_filter.svg" alt="" />
              </button>
            }
            @if (column.sortable) {
              <img [src]="getSortIcon(column)" class="sort-icon" alt="" />
            }
          </div>
        </th>
        <td
          mat-cell
          *matCellDef="let row"
          [class]="column.cellClass || ''"
          [style.min-width]="column.minWidth || null"
        >
          @if (getCellTemplate(column.key); as cellTemplate) {
            <ng-container
              *ngTemplateOutlet="
                cellTemplate;
                context: {
                  $implicit: row,
                  row: row,
                  value: getColumnValue(row, column),
                }
              "
            ></ng-container>
          } @else {
            {{ getColumnValue(row, column) }}
          }
        </td>
      </ng-container>
    }

    @if (rowActions.length > 0) {
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions-column" aria-label="Actions"></th>
        <td mat-cell *matCellDef="let row" class="actions-cell">
          @if (rowActionItems(row).length > 0) {
            <app-package-row-actions
              [testId]="testId + '-row-actions-' + rowId(row)"
              [items]="rowActionItems(row)"
              [ariaLabel]="'Actions'"
              (menuOpened)="onActionMenuOpened(row)"
              (action)="onRowActionSelected($event)"
            />
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      class="data-table-row"
      [class.clickable]="rowClickable"
      (click)="onRowClicked(row)"
    ></tr>
  </table>

  <!-- One shared menu avoids matMenuTriggerFor conflicts when several columns filter. -->
  <mat-menu
    #columnFilterMenu="matMenu"
    panelClass="data-table-filter-menu"
    xPosition="before"
    (closed)="onColumnFilterMenuClosed()"
  >
    @if (activeFilter; as filter) {
      <div class="filter-content" (click)="$event.stopPropagation()">
        <div class="filter-options">
          @for (option of filter.options; track option.value) {
            <div class="p-field-checkbox">
              <mat-checkbox
                [checked]="isFilterOptionSelected(filter.field, option.value)"
                (change)="onFilterOptionToggle(filter.field, option.value, $event.checked)"
              >
                <span class="p5">{{ option.label }}</span>
              </mat-checkbox>
            </div>
          }
        </div>
        <div class="filter-actions">
          <button
            type="button"
            class="btn btn-tertiary"
            [disabled]="getPendingFilterValues(filter.field).length === 0"
            (click)="clearActiveColumnFilter()"
          >
            Clear
          </button>
          <div class="right-buttons">
            <button
              type="button"
              class="btn btn-secondary btn-small"
              (click)="activeFilterTrigger?.closeMenu()"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-small"
              (click)="applyActiveColumnFilter()"
            >
              Apply
            </button>
          </div>
        </div>
      </div>
    }
  </mat-menu>
</div>
